import { LOGIN_TYPE, storageKey } from 'constants/index';

import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

export default {
  async getAdministratorsList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/administrators${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getExtranetAdministratorsList(payload) {
    const params = getParamsFormObject(payload);
    const path = `/extranet-administrators${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getExtranetAdministratorsPlaceManager(payload) {
    const params = getParamsFormObject(payload);
    const path = `/extranet-administrators/place-manager${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getAdministratorsDetail(adminId) {
    const path = `/administrators/${adminId}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addAdministrator(payload) {
    const path = '/administrators';

    await axiosClient.post(path, payload);
  },

  async deleteAdministrator(adminId) {
    const path = `/administrators/${adminId}`;

    await axiosClient.delete(path);
  },

  async editAdministrator(payload) {
    const { adminId, result } = payload;

    const path = `/administrators/${adminId}`;

    await axiosClient.put(path, result);
  },

  async createAdministratorPassword(payload) {
    const { result, token } = payload;

    const path = `/administrators/create-password?token=${token}`;

    await axiosClient.put(path, result);
  },

  async getActionHistoryList(payload) {
    const path = `/administrators/${payload}/action-histories`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getMyPermission() {
    const isIntranet = localStorage.getItem(storageKey.LOGIN_TYPE) === LOGIN_TYPE.INTRANET;

    const path = isIntranet ? '/profile-intranet/my-permission' : '/profile-extranet/my-permission';

    const response = await axiosClient.get(path);

    return response.data;
  },

  async getExtranetAdministratorDetail(payload) {
    const { id, place } = payload;
    const path = place
      ? `/extranet-administrators/${id}?place=${place}`
      : `/extranet-administrators/${id}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async editExtranetAdministrator(payload) {
    const { id, place, result } = payload;
    const path = place
      ? `/extranet-administrators/${id}?place=${place}`
      : `/extranet-administrators/${id}`;

    const response = await axiosClient.put(path, result);

    return response.data;
  },

  async deleteExtranetAdministrator(payload) {
    const { id, place } = payload;
    const path = `/extranet-administrators/${id}`;

    const response = await axiosClient.delete(path, { data: { place } });

    return response.data;
  },

  async resetExtranetAdministratorPassword(payload) {
    const { id, result } = payload;
    const path = `/extranet-administrators/${id}/reset-password`;

    const response = await axiosClient.put(path, result);

    return response.data;
  },

  async resetIntranetAdministratorPassword(payload) {
    const { id, result } = payload;
    const path = `/intranet-administrators/${id}/reset-password`;

    const response = await axiosClient.put(path, result);

    return response.data;
  },

  async checkExtranetEmail(payload) {
    const params = getParamsFormObject(payload);
    const path = `/extranet-administrators/check-email${params}`;

    const response = await axiosClient.get(path);

    return response.data;
  },

  async addExtranetAdministrator(payload) {
    const path = '/extranet-administrators';

    const response = await axiosClient.post(path, payload);

    return response.data;
  },
};
